export { default } from './BettingGame';
